export default __webpack_public_path__ + "static/media/cabinetProtectiaMuncii.757461a4.png";